
export const name = "unified-navigation-ui";
export const version = "dev";
